let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("3cIuP")).then(() => parcelRequire('jWG2r'));